import queryString from "query-string";

export default function shouldHideFilterSectionInListingPage(listingPage, filterType) {
  if (!listingPage) return false;

  const parsedFilters = queryString.parse(listingPage.search_query, { arrayFormat: "bracket" });
  const parsedFiltersKeys = Object.keys(parsedFilters);

  return parsedFiltersKeys.includes(filterType);
}
